import { connect } from 'react-redux'
import {
  postYelStart,
  getYelStart,
  getUserYelInfo,
  closeYelSnackbar
} from '../../actions/index'
import Yel from '../../components/profile/yel.component'

const mapStateToProps = (state) => {
  const { client, adminUser } = state
  const userType = client.user.data[5]

  //const formValues = getFormValues('yel')(state)

  return {
    //showFirstTimer: formValues.yelSelect === 'yel_recommended' || formValues.yelSelect === 'yel_minimum',
    showYelSnackbar: state.tax.showYelSnackbar,
    showYelFailSnackbar: state.tax.showYelFailSnackbar,
    isYelIncomeLock: state.tax.isYelIncomeLock,
    userType,
    selectedUser: adminUser.selectedUser,
    isYelSelectionLock: state.tax.isYelSelectionLock
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    postYelStart: (formValues) => dispatch(postYelStart(formValues)),
    getYelStart: () => dispatch(getYelStart()),
    getUserYelInfo: (userData) => dispatch(getUserYelInfo(userData)),
    closeYelSnackbar: () => dispatch(closeYelSnackbar())
  }
}

const YelContainer = connect(mapStateToProps, mapDispatchToProps)(Yel)

export default YelContainer
